// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__31fHb","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3GhFc"};